<template>
  <div class="page-chat">
    <div class="mt-4">
      <div class="container-chat">
        <div class="header">
          <p class="title">{{ $t("page.labels.incidence_tracking") }}</p>
          <p class="subtitle" v-if="referenceParcel">{{ referenceParcel }}</p>
          <p class="info" v-if="nameContact">Estás hablando con {{ nameContact }}</p>
        </div>

        <div ref="chatDiv" class="chat" v-if="enquiryComments.length">
          <div v-for="comment in enquiryComments" :key="comment.date">
            <p class="has-text-centered mb-2">{{ comment.date }}</p>
            <div v-for="message in comment.messages" :key="message.id">
              <div class="message" :class="checkManager(message.user)">
                <div class="header-message">
                  <p v-if="!checkManager(message.user)">{{ message.user.username }}</p>
                  <p v-if="checkManager(message.user)">{{ $t("page.labels.me") }}</p>
                  <p>{{ formatDate(message.created_on) }}</p>
                </div>
                <p class="text">{{ message.description }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="chat" v-if="!enquiryComments.length">
          <div class="message right">
            <p class="text p-2">{{ $t("page.labels.no_messages") }}</p>
          </div>
        </div>
        <div class="input-chat">
          <form
            id="formCreateEnquiryComment"
            action=""
            @submit.prevent="createEnquiryComment"
          >
            <div class="field is-grouped mr-3">
              <p class="control is-expanded">
                <textarea
                  class="textarea is-lightgreen has-fixed-size"
                  v-model="description"
                  name="description"
                  required
                  rows="1"
                  id="taDescription"
                ></textarea>
              </p>
              <p class="control">
                <button class="button btn-chat is-outlined" type="submit">
                  {{ $t("page.buttons.send") }}
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api"
export default {
  name: "enquiry-chat",
  data() {
    return {
      enquiryComments: [],
      description: "",
      nameContact: null,
      referenceParcel: null,
    }
  },
  mounted() {
    this.getComments()
    this.getRefCertifiedParcel()
    this.$store.commit("setHideFooter", true)
  },
  updated() {
    this.changeScroll()
  },
  beforeDestroy() {
    this.$store.commit("setHideFooter", false)
  },
  methods: {
    changeScroll() {
      if (!this.$refs.chatDiv) {
        return
      }

      this.$refs.chatDiv.scrollTop = 9999
    },
    getComments() {
      this.$store.dispatch("loadComments", this.$route.params.enquiryId).then(() => {
        this.enquiryComments = this.$store.getters.getComments
        this.getNameContact(this.enquiryComments[0].messages)
      })
    },
    createEnquiryComment() {
      api
        .createEnquiryComment(this.$route.params.enquiryId, this.description)
        .then(() => {
          this.getComments()
          this.description = ""
        })
    },
    checkManager(user) {
      const formatName = `${user.first_name} ${user.last_name}`
      if (this.$store.getters.userFullname === formatName) {
        return "right"
      }
    },
    getNameContact(messages) {
      messages.forEach((message) => {
        if (!this.checkManager(message.user)) {
          this.nameContact = message.user.first_name
            ? `${message.user.first_name} ${message.user.last_name}`
            : message.user.username
          return
        }
      })
    },
    getRefCertifiedParcel() {
      this.referenceParcel = this.$store.state.parcel.parcel
        ? this.$store.state.parcel.parcel.cadastral_ref
        : null
    },
    formatDate(date) {
      return this.$moment(date).format("HH:mm")
    },
  },
}
</script>
